// export const API_URL = 'https://jsonplaceholder.typicode.com';
// http://nassfoods.api.syskodeprojects.tech/N0001/api/users/docs#/Auth/UserAuthController_login

const DEV_BASE_URL = 'https://dev-panel.nassfoods.com';
// const DEV_BASE_URL = `https://nassfoods.api.syskodeprojects.tech`
const LIVE_BASE_URL = 'https://prod-panel.nassfoods.com';
const MODE = 'dev' as 'dev' | 'production';
const CurrentUrl = MODE === 'dev' ? DEV_BASE_URL : LIVE_BASE_URL;

export const API_URL = `${CurrentUrl}/N0001/api/v1`;

export const API_URL_PRODUCT_SERVICE = `${CurrentUrl}/N0003/api/v1`;

export const API_URL_ORDER_SERVICE = `${CurrentUrl}/N0004/api/v1`;

export const API_URL_USER_SERVICE = `${CurrentUrl}/N0001/api/v1`;

export const API_URL_NOTIFICATION_SERVICE = `${CurrentUrl}/N0002/api/v1`;

export const API_URL_LOYALTY_SERVICE = `${CurrentUrl}/N0007/api/v1`;

export const API_URL_REPORT_SERVICE = `${CurrentUrl}/N0009/api/v1`;

export const API_URL_CMS_SERVICE = `${CurrentUrl}/N0008/api/v1`;

export const API_ENDPOINT = {
  todo: '/todos/',
  auth: '/auth',
  session: '/session',
  roles: '/roles',
  sync: '/sync',
  products: '/products',
  variants: '/variants',
  order: '/order',
  coupons: '/coupons',
  categories: '/categories',
  media: '/media',
  brands: '/brands',
  users: '/user',
  spin: '/spin',
  bundles: '/bundles',
  settings: '/settings',
  cart: '/cart',
  notification: '/notification',
  rating: '/rating',
  dashboard: '/dashboard',
  refund: '/refund',
  content: '/content',
  erp: 'erp',
  homeLayout: '/home-layout',
};
